export class LayoutSetting {
    public logoPath: string;
    public showHome: boolean;
    public campanyName: boolean;
    public showLanguage: boolean;
    public showKey: boolean;
    public showLogOut: boolean;
}
